import { Link } from 'react-router-dom';

function Navbar() {
  return (
    <nav className="navbar">
      <Link to="/" className="navbar-logo">Doccy</Link>
      <ul className="navbar-links">
        <li><Link to="/">Home</Link></li>
        <li><Link to="/help">Help</Link></li>
        <li><Link to="/privacy">Privacy</Link></li>
      </ul>
    </nav>
  );
}

export default Navbar;
